import React from "react";
import {
  Button,
  Box,
  Typography,
  Stack,
  Avatar,
  TextField,
  useTheme,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";

import calculateNameInitial from "../../../../util/calculateNameInitial";
import { buttonCommonStyle, inputCommonStyle } from "../../../../util/admin/cssCommonStyle";

const UserDetailsCard = ({ userDetails }) => {

  const nameInitials = calculateNameInitial(userDetails?.name);
  const muiTheme = useTheme();
  
  return (
    <Stack
      direction="row"
      justifyContent="space-around"
      sx={{
        backgroundColor: "white",
        display: "flex",
        borderRadius: "4px",
        p: "10px 12px",
        maxWidth: "75%",
        my: 4,
        mx: "auto",
      }}
    >
      <Avatar
        sx={{
          width: 140,
          height: 140,
          fontSize: "5rem",
          fontWeight: "bold",
          borderRadius: "50%",
        }}
        alt="User Profile Picture"
      >
        {nameInitials}
      </Avatar>
      <Stack direction="column" justifyContent="center" gap={2}>
        <Stack direction="row" gap={5} alignItems="center">
          <Box sx={{ flexBasis: "30%" }}>
            <Typography sx={{ fontWeight: "bold" }}>User Name</Typography>
          </Box>
          <Box sx={{ flexBasis: "70%" }}>
            <TextField
              id="outlined-basic"
              variant="outlined"
              size="small"
              value={userDetails?.username}
              fullWidth
              sx={inputCommonStyle}
            />
          </Box>
        </Stack>
        <Stack direction="row" gap={5} alignItems="center">
          <Box sx={{ flexBasis: "30%" }}>
            <Typography sx={{ fontWeight: "bold", textAlign: "center" }}>
              Name
            </Typography>
          </Box>
          <Box sx={{ flexBasis: "70%" }}>
            <TextField
              id="outlined-basic"
              variant="outlined"
              size="small"
              fullWidth
              value={userDetails?.name}
              sx={inputCommonStyle}
            />
          </Box>
        </Stack>
      </Stack>

      <Stack direction="column"  mt={"28px"}>
        <Stack direction="row"  alignItems="center">
          <Box sx={{ flexBasis: "30%" }}>
            <Typography sx={{ fontWeight: "bold", textAlign: "center" }}>
              Email
            </Typography>
          </Box>
          <Box sx={{ flexBasis: "70%" }}>
            <TextField
              id="outlined-basic"
              variant="outlined"
              size="small"
              fullWidth
              value={userDetails?.email}
              sx={inputCommonStyle}
            />
          </Box>
        </Stack>
        <Stack>
          <Box
            sx={{
              flexBasis: "70%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {/* <Button variant="outlined" sx={buttonCommonStyle}>
              <AddCircleIcon
                sx={{
                  marginRight: "4px",
                  fontSize: "24px",
                  color: muiTheme.palette.primary.main,
                  opacity: 1,
                }}
              />
              Add New User
            </Button> */}
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default UserDetailsCard;
